import { deleteCookie, setCookie } from 'cookies-next';
import { API, SignInAPI, getDomainForCookie } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBase, ResponseBaseWithData } from '~types/response';

interface Response extends ResponseBase {
  data: {
    accessToken: string;
  };
}

/**
 * 로그인
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/user-sign-controller/signIn
 */
export function signIn(payload: AuthModel.SignInRequest) {
  return SignInAPI.post<Response>('/api/v2/users/sign-in', { data: payload });
}

export async function signOut() {
  deleteCookie('accessToken', {
    domain: getDomainForCookie(),
  });
  deleteCookie('accessToken');
  deleteSuperToken();
}

export const deleteSuperToken = () => {
  deleteCookie('access_super_token');
  deleteCookie('access_super_token', {
    domain: getDomainForCookie(),
  });
};

export const setSuperToken = (token: string) => {
  setCookie('access_super_token', token, {
    domain: getDomainForCookie(),
  });
};

interface SignInByTokenRequest {
  token: string;
  isMobile?: boolean;
}

interface SignInByTokenResponse extends ResponseBase {
  data: {
    accessToken: string;
  };
  // 필요에 따라 추가 필드 작성
}

export function signInByMagicLinkToken(payload: SignInByTokenRequest) {
  return SignInAPI.post<SignInByTokenResponse>('/api/v2/users/sign-in-by-magic-link-token', {
    data: payload,
  });
}

export function getMagicLink(userId: string) {
  return API.post<
    ResponseBaseWithData<{
      magicLink: string;
    }>
  >(`/api/v2/users/${userId}/get-magic-link`);
}

interface VerifySuperTokenRequest {
  token: string;
}

interface VerifySuperTokenResponse extends ResponseBase {
  data: {
    userId: string;
    userName: string;
    companyId: string | null;
    issuer: string;
  };
}

/**
 * Super Token 검증 (클로브용)
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/user-sign-controller/verifySuperToken
 */
export function verifySuperToken(payload: VerifySuperTokenRequest) {
  return SignInAPI.post<VerifySuperTokenResponse>('/api/v2/users/verify-super-token', {
    data: payload,
  });
}
